import { Suspense } from "react";
import {
  locationShape,
  Intl,
  Layout,
  configureApplication,
  ApplicationContext,
  url,
  Loader,
} from "lcm-iot-commons";
import Navigation from "../components/Navigation";

import { SignUpContextProvider } from "../context/SignUpContext";
import "react-widgets/lib/scss/react-widgets.scss";
import "../assets/styles/main.scss";
import { mergeAppMessages } from "../translations";

configureApplication({
  BASE_URL: "/app/id",
});

const UNSECURED_ENDPOINTS = [
  url("/sign_in"),
  url("/sign_up"),
  url("/sign_up_success"),
  url("/sign_up_complete"),
  url("/session_expired"),
  url("/sign_in_confirmation"),
  url("/request_password_reset"),
  url("/password_reset"),
  url("/confirmation"),
  url("/404"),
  url("/403"),
  url("/500"),
];

type OwnSsoRootProps = {
  children?: React.ReactNode;
  location?: locationShape;
};

const defaultProps: Partial<OwnSsoRootProps> = {
  children: undefined,
  location: undefined,
};

type SsoRootProps = OwnSsoRootProps & typeof defaultProps;

export function SsoRoot({ location, children }: SsoRootProps) {
  return (
    <SignUpContextProvider>
      <Suspense fallback={<Loader />}>
        <Intl mergeAppMessages={mergeAppMessages}>
          {/* @ts-expect-error TS(2322) FIXME: Type '{ children: Element; unsecuredEndpoints: str... Remove this comment to see the full error message */}
          <ApplicationContext unsecuredEndpoints={UNSECURED_ENDPOINTS}>
            <span>
              {/* @ts-expect-error TS(2322) FIXME: Type '{ location: locationShape | undefined; }' is... Remove this comment to see the full error message */}
              <Navigation location={location} />
              <div className="navbar-separator" />
              <Layout>{children}</Layout>
            </span>
          </ApplicationContext>
        </Intl>
      </Suspense>
    </SignUpContextProvider>
  );
}

SsoRoot.defaultProps = defaultProps;

export default SsoRoot;
